import { SVGProps } from 'react';
import { colors } from 'syngenta-digital-cropwise-react-ui-kit';

const IconSettings = ({
  height = '18px',
  width = '18px',
  color = colors.neutral60,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.6825 1.5L10.0425 3.465C10.485 3.6375 10.8975 3.8625 11.2725 4.14L13.1175 3.24L14.76 5.2425L13.17 6.63C13.2825 7.0875 13.2825 7.5525 13.17 8.01L14.76 9.3975L13.1175 11.4L11.2725 10.5C10.8975 10.7775 10.485 11.0025 10.0425 11.175L9.6825 13.14H6.3975L6.0375 11.175C5.595 11.0025 5.1825 10.7775 4.8075 10.5L2.9625 11.4L1.32 9.3975L2.91 8.01C2.7975 7.5525 2.7975 7.0875 2.91 6.63L1.32 5.2425L2.9625 3.24L4.8075 4.14C5.1825 3.8625 5.595 3.6375 6.0375 3.465L6.3975 1.5H9.6825ZM8.04 10.5C9.5175 10.5 10.71 9.3075 10.71 7.83C10.71 6.3525 9.5175 5.16 8.04 5.16C6.5625 5.16 5.37 6.3525 5.37 7.83C5.37 9.3075 6.5625 10.5 8.04 10.5ZM8.04 6.66C8.685 6.66 9.21 7.185 9.21 7.83C9.21 8.475 8.685 9 8.04 9C7.395 9 6.87 8.475 6.87 7.83C6.87 7.185 7.395 6.66 8.04 6.66Z"
      fill={color}
    />
  </svg>
);

export default IconSettings;
